/**
 * 사용자가 ACTIVE 상태의 팀에 소속되어 있는지 확인
 */
export function hasActiveTeam(teams: { status?: string }[]): boolean {
  return teams.some(team => team.status === 'ACTIVE');
}

/**
 * ACTIVE 상태의 팀 중 지정된 ID의 팀을 반환
 * @param teams 팀 목록
 * @param activeTeamId 활성 팀 ID (선택 사항)
 * @returns 활성 팀 또는 null
 */
export function getActiveTeam<T extends { teamId: number; status?: string }>(
  teams: T[],
  activeTeamId?: number | null
): T | null {
  const activeTeams = teams.filter(team => team.status === 'ACTIVE');
  if (activeTeamId) {
    return activeTeams.find(t => t.teamId === activeTeamId) ?? null;
  }
  return activeTeams[0] ?? null;
}

/**
 * ACTIVE 상태의 첫 번째 팀 ID를 반환
 */
export function getFirstActiveTeamId(teams: { teamId: number; status?: string }[]): number | null {
  const activeTeam = teams.find(team => team.status === 'ACTIVE');
  return activeTeam?.teamId ?? null;
}
